export default __webpack_public_path__ + "static/media/inak.9e7f2ca3.png";